'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _adapters = require('../adapters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    id: 'com.worldpay.enterprise',

    form: [{ type: 'string', name: 'merchantCode' }, { type: 'string', name: 'merchantPassword' }],

    countries: ['BE', 'CH', 'DE', 'DK', 'ES', 'FI', 'FR', 'GB', 'HK', 'IE', 'IT', 'LU', 'NL', 'NO', 'SE', 'SG', 'US'],

    fields: [],

    formValuesToMerchant: _adapters.simpleFormValuesToMerchant,
    merchantToFormValues: _adapters.simpleMerchantToFormValues,
    keyToMerchant: JSON.parse,
    merchantToKey: _stringify2.default,

    ranking: 2
};